<template>
  <div class="flex flex-col">
    <h2>Alimentos</h2>

    <router-link
      v-if="hasPermission('edit_diet_categories')"
      :to="{ name: 'dietCategoriesForm' }"
      class="primary-button mx-0 mt-2"
      >Crear Alimento</router-link
    >

    <div v-if="!loading">
      <div
        v-for="category in dietCategories"
        :key="category.id"
        class="card my-6"
      >
        <h2>{{ category.name }}</h2>
        <table class="table-auto text-sm mt-4 bg-white">
          <thead class="text-left">
            <tr class="bg-primary-100">
              <th class="px-4 py-3 rounded text-xs font-semibold text-primary-700 uppercase tracking-wide">Subcategorías</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="subcategory in category.diet_subcategories"
              :key="subcategory.id"
              class="table-row"
            >
              <td class="table-cell">
                {{ subcategory.name }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div v-else class="flex w-full h-full items-center">
      <loader-icon class="h-10 w-10 text-primary-500 mx-auto"></loader-icon>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import { formatDatetime } from "@/utils/dateFormatter";
import { integerToCurrency } from "@/utils/currencyFormatter";
export default {
  name: "Diet Categories",

  data() {
    return {
      dietCategories: null,
      loading: false,
    };
  },

  created() {
    this.$store.commit("setSelectedTab", "dietCategories");

    this.loadDietCategories();
  },

  methods: {
    formatDatetime,

    integerToCurrency,

    async loadDietCategories() {
      this.loading = true;

      try {
        this.dietCategories = await api.dietCategories.getAll();
      } catch (error) {
        console.log(error);
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
      }

      this.loading = false;
    },
  },
};
</script>